export const themeConfig = {
	components: {
		Checkbox: {
			fontFamily: 'Public Sans',
			colorPrimary: '#003399',
			algorithm: true,
		},
		Select: {
			fontFamily: 'Public Sans',
			colorPrimary: '#003399',
			algorithm: true,
		},
		Typography: {
			colorPrimary: '#003399',
			algorithm: true,
			fontFamily: 'Public Sans',
		},
		Button: {
			colorPrimary: '#003399',
			algorithm: true,
			fontFamily: 'Public Sans',
		},
		Radio: {
			colorPrimary: '#003399',
			algorithm: true,
			fontFamily: 'Public Sans',
		},
		Input: {
			fontFamily: 'Public Sans',
			colorPrimary: '#003399',
			algorithm: true,
		},
		InputNumber: {
			fontFamily: 'Public Sans',
			colorPrimary: '#003399',
			algorithm: true,
		},
		Spin: {
			fontFamily: 'Public Sans',
			colorPrimary: '#003399',
			algorithm: true,
		},
		Steps: {
			fontFamily: 'Public Sans',
			colorPrimary: '#003399',
			algorithm: true,
		},
		Table: {
			fontFamily: 'Public Sans',
			colorPrimary: '#003399',
			algorithm: true,
		},
		Tabs: {
			fontFamily: 'Public Sans',
			colorPrimary: '#003399',
			algorithm: true,
		},
		Pagination: {
			fontFamily: 'Public Sans',
			colorPrimary: '#003399',
			algorithm: true,
		},
	},
};
